import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { BUTTON_TYPE, SLIDER_TYPES } from 'consts/enum';
import { LS } from 'consts/localStorage';
import {
	generate6DigitUUID,
	generateUUID,
	removeElement,
	setCustomTagHTML,
	storeSkipInLS,
	writeToLs,
} from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { Button } from 'ui/button/button.module';
import { sliderData } from './slider.model';
import { SliderTemplate } from './slider.template';

const { RATING, NUMBER, PERCENTAGE } = SLIDER_TYPES;
export default class Slider {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = sliderData;

		const {
			user_prompt,
			message_id,
			input_type,
			max_label,
			min_label,
			scale,
			step_value,
			validation_message,
			zero_index,
		} = propData.message?.data;
		this.data.id = propData.id || propData.message_id || `message-${generate6DigitUUID()}`;
		this.setter({
			...propData,
			userPrompt: user_prompt,
			input_type,
			maxLabel: max_label,
			minLabel: min_label,
			scale,
			stepValue: step_value,
			id: message_id,
			zeroIndex: zero_index,
			validationMessage: validation_message,
		});
		this.data.id = propData.id || propData.message_id || `message-${generate6DigitUUID()}`;
	}

	initWrapper() {
		this.html = new MessageWrapper({
			...this.data,
			innerHTML: SliderTemplate(this.data),
		});
	}

	getMessageId() {
		return `${ENGT_CHAT.get('config.botRef')}_${generateUUID()}`;
	}

	sendSliderValueAsMessage(generatedMessageId, data) {
		const msgBody = {
			bot_key: ENGT_CHAT.get('config.bot_key'),
			user_id: ENGT_CHAT.get('status.sessionKey'),
			ack: ENGT_CHAT.get('ack') + 1,
			key: ENGT_CHAT.get('config.key'),
			message_id: generatedMessageId,
		};

		ENGT_CHAT.get('sendMessage')(data.text, {
			...msgBody,
			message: data,
			tab_msg_action: ENGT_CHAT.get('config.isCtaResponseHidden') ? 'skip' : '',
			skipAppendToDom: ENGT_CHAT.get('config.isCtaResponseHidden'),
		});
	}

	initComponents() {
		const ref = this;
		const { message, input_type, maxLabel } = this.data || {};
		const { data: messageData } = message;
		const skip = messageData?.enable_skip;
		const skipPostBack = messageData?.skip_postback;
		const generatedMessageId = `${ENGT_CHAT.get('config.botRef')}_${generateUUID()}`;
		const slider = this.html.querySelector(`#engt-slider-input-${this.data.id}`);
		const isOldMsg = this.data.isOldMessage;

		const confirmButton = !isOldMsg
			? new Button({
					type: BUTTON_TYPE.PRIMARY,
					label: ENGT_CHAT.get('GENERIC_STRINGS')?.['SUBMIT'] || 'Submit',
					id: 'confirmBtn',
					applyOnHover: true,
					dataInteractiveField: true,
					onClick() {
						const slider = ref.html.querySelector(`#engt-slider-input-${ref.data.id}`);
						const skip = ref.html.querySelector('#skipBtn');
						let value = 0;
						let disableLabels = false;

						if (input_type === PERCENTAGE || input_type === NUMBER) {
							if (parseInt(slider.value) >= parseInt(maxLabel.value)) {
								value = `${maxLabel.value}.00`;
							} else {
								value = `${slider.value}.00`;
							}
						} else {
							ref.html.querySelector(`#engtSliderLabels-${ref.data.id}`).style.pointerEvents = 'none';
							disableLabels = true;

							if (parseInt(slider.value) === 0) {
								value = 1;
							} else {
								value = slider.value;
							}
						}

						setTimeout(
							() =>
								writeToLs(
									LS().TAB_MESSAGES,
									JSON.stringify({
										action: 'update_slider_msg',
										id: `${ref.data.id}`,
										selectedValue: value,
										percentage: ref.percentage,
										disableLabels,
										confirmBtnId: 'confirmBtn',
										tabId: ENGT_CHAT.get('socketId'),
									})
								),
							500
						);

						const data = {
							text: value,
							type: 'text',
						};

						ref.sendSliderValueAsMessage(generatedMessageId, data);
						ref.disableInput();
						ref.showValuePreview(ref);
						removeElement(confirmButton);
						skip && removeElement(skipButton);
						ENGT_CHAT.get('enableAllInput')();
					},
					radius: 18,
			  }).render()
			: '';

		const skipButton =
			skip && !isOldMsg
				? new Button({
						type: BUTTON_TYPE.MINI,
						label: ENGT_CHAT.get('GENERIC_STRINGS')?.['SKIP'] || 'Skip',
						id: 'skipBtn',
						style: 'margin-top: 12px;',
						applyOnHover: true,
						onClick() {
							ref.onSkip(skipPostBack);
							ref.reset();
							ref.disableInput();
							this.parentNode.removeChild(confirmButton);
							this.parentNode.removeChild(this);
							setTimeout(
								() =>
									writeToLs(
										LS().TAB_MESSAGES,
										JSON.stringify({
											action: 'update_slider_msg',
											id: `${ref.data.id}`,
											selectedValue: 'skip',
											confirmBtnId: 'confirmBtn',
											tabId: ENGT_CHAT.get('socketId'),
										})
									),
								500
							);
							storeSkipInLS();
							ENGT_CHAT.get('enableAllInput')();
						},
						radius: 18,
				  }).render()
				: '';

		setCustomTagHTML(this.html.querySelector('confirm-btn'), confirmButton);
		setCustomTagHTML(this.html.querySelector('skip-btn'), skipButton);

		isOldMsg && ref.disableInput();
	}

	initEventHandlers() {
		const ref = this;
		const { input_type, scale, id, maxLabel, minLabel } = this.data;
		const slider = this.html.querySelector(`#engt-slider-input-${id}`);

		slider.addEventListener('input', function () {
			ref.onInputChange.call(this, ref);
			ref.onFocus.call(this, ref);
		});
		slider.addEventListener('mousemove', function () {
			ref.onFocus.call(this, ref);
		});
		slider.addEventListener('mouseleave', function () {
			ref.onFocusOut.call(this, ref);
		});

		if (input_type === RATING) {
			const labelContainer = document.createElement('div');
			labelContainer.id = `engtSliderLabels-${id}`;
			labelContainer.className = 'engt-custom-range-slider__label';
			labelContainer.style.padding = '0px 4px';
			labelContainer.style.marginBottom = '6px';

			for (let i = 1; i <= scale; i++) {
				const label = document.createElement('span');
				label.innerText = i;
				label.style.cursor = 'pointer';
				label.addEventListener('click', () => {
					slider.value = i;
					ref.onInputChange.call(slider, ref);
				});
				labelContainer.appendChild(label);
			}
			const labelsContainerForRating = document.createElement('div');
			labelsContainerForRating.className = 'engt-custom-range-slider__label';
			const labelForMin = document.createElement('span');
			labelForMin.innerText = minLabel.name;
			labelsContainerForRating.appendChild(labelForMin);
			const labelForMax = document.createElement('span');
			labelForMax.innerText = maxLabel.name;
			labelsContainerForRating.appendChild(labelForMax);
			this.html.querySelector('.engt-slider').appendChild(labelContainer);
			this.html.querySelector('.engt-slider').appendChild(labelsContainerForRating);
		}

		this.onInputChange.call(slider, this); // init gradient color at start
	}

	onInputChange(ref) {
		const { input_type, maxLabel } = ref.data;
		const label = ref.html.querySelector(`#engt-slider-val-${ref.data.id}`);
		let percentage =
			((parseInt(this.value) - parseInt(this.min)) / (parseInt(this.max) - parseInt(this.min))) * 100;

		if (percentage < 20) percentage += 2.5;
		else if (percentage < 30) percentage += 2.5;
		else if (percentage < 40) percentage += 1.5;
		else if (percentage > 40 && percentage < 70) percentage -= 0.5;
		else if (percentage > 70 && percentage < 90) percentage -= 1.5;
		else if (percentage > 90 && percentage !== 100) percentage -= 2.5;
		ref.percentage = percentage;

		this.style.background = `linear-gradient(90deg, ${ENGT_CHAT.get(
			'config.buttonSelectorColor'
		)} ${percentage}%, #fff 0)`;

		if (label) {
			if (input_type === PERCENTAGE || input_type === NUMBER) {
				if (parseInt(this.value) >= parseInt(maxLabel.value)) {
					label.innerText = `${maxLabel.value}%`;
				} else {
					label.innerText = `${this.value}%`;
				}
			} else {
				label.innerText = `${this.value}%`;
			}
		}
	}

	onFocus(ref) {
		const { maxLabel } = ref.data || {};
		const sliderValuePreview = ref.html.querySelector('.engt-slider-value-preview');
		const percentage = ref.percentage ? (ref.percentage < 5 ? 5 : ref.percentage >= 98 ? 70 : ref.percentage) : 5;
		sliderValuePreview.innerText = this.value > maxLabel.value ? maxLabel.value : this.value;
		if (ref.percentage >= 98) {
			sliderValuePreview.style.right = '24px';
			sliderValuePreview.style.left = 'unset';
		} else {
			sliderValuePreview.style.left = `calc(${parseInt(percentage)}% + 14px)`;
			sliderValuePreview.style.right = 'unset';
		}

		ref.showValuePreview(ref);
	}

	onFocusOut(ref) {
		ref.hideValuePreview(ref);
	}

	showValuePreview(ref) {
		const sliderValuePreview = ref.html.querySelector('.engt-slider-value-preview');
		sliderValuePreview.style.display = 'block';
	}

	hideValuePreview(ref) {
		const sliderValuePreview = ref.html.querySelector('.engt-slider-value-preview');
		sliderValuePreview.style.display = 'none';
	}

	onSkip(payload) {
		if (payload && (payload !== null || payload !== 'null')) {
			ENGT_CHAT.get('sendMessage')('skip', {
				message: {
					postback: payload,
					type: 'postback',
					text: 'skip',
				},
				tab_msg_action: 'skip',
				skipAppendToDom: true,
			});
		}
	}

	reset() {
		const { minLabel, id } = this.data || {};
		const slider = this.html.querySelector(`#engt-slider-input-${id}`);
		slider.value = minLabel.value;
		slider.style.background = `linear-gradient(90deg, ${ENGT_CHAT.get('config.buttonSelectorColor')} 0%, #fff 0)`;
	}

	disableInput() {
		const { id } = this.data || {};
		const slider = this.html.querySelector(`#engt-slider-input-${id}`);
		slider.disabled = true;
		slider.removeEventListener('input', this.onInputChange);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
